import ViewBase from "../../view-base.view";
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import Polyline from 'ol/format/Polyline';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Feature, Overlay } from 'ol';
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";
import Fill from "ol/style/Fill";
import CircleStyle from 'ol/style/Circle';
import { Point } from "ol/geom";
import Text from "ol/style/Text";
import 'CssFolder/schedule/jpo/jpo-map.scss';
import { v4 as uuid } from "uuid";
import { toStringHDMS } from "ol/coordinate";
import { fromLonLat, toLonLat } from "ol/proj";

export default function JPOScheduleMapView() {
    ViewBase.call(this);
    let map;
    let routes = [];
    let schedules = [];
    let icons = [];
    let vectorSources = [];
    let dataVersion = "";
    let id = uuid();
    let zoom = 5;
    let colors = [];
    let pop_container;
    let pop_content;
    let pop_closer;
    let pop_overlay;

    const drawIcon = () => {
        const vs1 = new VectorSource({
            features: icons,
        });
        const v1 = new VectorLayer({
            map: map,
            source: vs1,
            style: (feature) => {
                let type = feature.get('type');


                return [new Style({
                    zIndex: 1000,
                    text: new Text({
                        text: type == "sicon" ? '' : `${feature.get('index') + 1}`,
                        font: '14px Calibri,sans-serif',
                        fill: new Fill({ color: '#fff' }),
                        stroke: new Stroke({
                            color: 'black',
                            width: 1,
                        }),
                        textAlign: 'center',
                        textBaseline: 'hanging',
                        offsetX: 0,
                        offsetY: -30,
                    }),
                    image: new Icon({
                        anchor: [0.5, 1],
                        src: type == "sicon" ? 'static/images/pin-home.svg' : 'static/images/ping.svg',
                        color: `rgba(${feature.get("color")})`,
                    }),
                })];


            },
        });


        vectorSources.push(vs1);
    }
    const drawRoute = (sroute, gindex, index, color) => {

        const styles = {
            'route': new Style({
                stroke: new Stroke({
                    width: 4,
                    color: color,
                }),
            }),
            'geoMarker': new Style({
                image: new CircleStyle({
                    radius: 5,
                    fill: new Fill({ color: 'black' }),
                    stroke: new Stroke({
                        color: 'white',
                        width: 2,
                    }),
                }),
            }),
        };

        const route = new Polyline({
            factor: 1e5,
        }).readGeometry(sroute.geometry, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
        });

        let fistCoord = route.getFirstCoordinate();
        let lastCoord = route.getLastCoordinate();

        const routeFeature = new Feature({
            type: 'route',
            geometry: route,
            unique: `${gindex}-${index}-1`,
            zIndex: 0,
            groupId: gindex
        });
        const startMarker = new Feature({
            type: 'sicon',
            geometry: new Point(fistCoord),
            index: index,
            unique: `${gindex}-${index}-2`,
            color: color,
            data: sroute,
            groupId: gindex
        });
        const endMarker = new Feature({
            type: 'eicon',
            geometry: new Point(lastCoord),
            index: index,
            unique: `${gindex}-${index}-3`,
            color: color,
            data: sroute,
            groupId: gindex
        });
        if (index == 0) {
            icons.push(startMarker);
        }
        icons.push(endMarker);

        const vs1 = new VectorSource({
            features: [routeFeature],
        });
        const v1 = new VectorLayer({
            map: map,
            source: vs1,
            style: function (feature) {
                return styles[feature.get('type')];
            },
        });
        vectorSources.push(vs1);

        if (index == 0) {
            const view = map.getView();
            view.setCenter(route.getFirstCoordinate());
        }

    }
    const loadRoutes = () => {
        let unique = [...new Set(schedules.map(u => u.userID))];

        routes = unique.map(u => {
            return {
                userID: u,
                routes: schedules.filter(s => s.userID == u).map((s, i) => {
                    return {
                        geometry: s.geometry,
                        sequence: i,
                        siteName: s.siteName,
                        startTime: s.startTime,
                        endTime: s.endTime
                    }
                })
            };
        });

        vectorSources.forEach(v => {
            const features = v.getFeatures();
            features.forEach(f => {
                v.removeFeature(f);
            });
        });
        map.render();
        icons = [];
        vectorSources = [];
        routes.forEach((e, i) => {
            // if(i!=3){return}
            e.routes.forEach((r, j) => {
                drawRoute(r, i, j, colors[i]);
            });
        });
        drawIcon();
        
    }

    const onCreate = () => {

        if (map != undefined) {
            return;
        }

        pop_container = document.getElementById(`popup-${id}`);
        pop_content = document.getElementById(`popup-content-${id}`);
        pop_closer = document.getElementById(`popup-closer-${id}`);

        pop_overlay = new Overlay({
            element: pop_container,
            autoPan: {
                animation: {
                    duration: 250,
                },
            },
        });
        map = new Map({
            view: new View({
                zoom: zoom,
                center:fromLonLat([115.312500,29.075375])
            }),
            overlays: [pop_overlay],
            layers: [
                new TileLayer({
                    source: new OSM({
                        attributions: ''
                    }),
                }),
            ],
            target: id
        });

        pop_closer.onclick = () => {
            pop_overlay.setPosition(undefined);
            pop_closer.blur();
            return false;
        }

        map.on('click', function (e) {
            var features = {};
            map.forEachFeatureAtPixel(e.pixel, (feature) => {
                if (feature.get('type') === "eicon") {
                    features[feature.get('unique')] = feature;
                }
            });

            if (Object.keys(features).length == 0) {
                pop_closer.click();
                return;
            }
            pop_content.innerHTML = Object.keys(features).map(f => {
                let data = features[f].get('data');
                let index = features[f].get('index') + 1;
                return {
                    html: `<div><div><span class="ol-popup-num" style="background:rgba(${features[f].get('color')});">${index}</span>&nbsp;${data.siteName}</div> <div style="padding-left: 28px;">⏲ ${data.startTime} ~ ${data.endTime}</div></div>`,
                    o1: features[f].get('groupId'),
                    o2: index
                }
            }).sort((a, b) => {
                return a.o1 === b.o1 ? a.o2 - b.o2 : a.o1 - b.o1;
            }).map(d => d.html).join(' ');

            const coordinate = e.coordinate;
            pop_overlay.setPosition(coordinate);
            pop_content.scrollTo(0, 0);
        });
    }

    return {
        oninit: ({ attrs }) => {
            colors = attrs.colors;
            schedules = attrs.schedules;
            zoom = attrs.zoom || 5;
        },
        oncreate: function (vnode) {
            onCreate();
        },
        onupdate: (vnode) => {

            if (vnode.attrs.dataVersion !== dataVersion) {
                schedules = vnode.attrs.schedules;
                dataVersion = vnode.attrs.dataVersion;
                loadRoutes();
            }
        },
        view: (vnode) => {
            return [
                m(`.ol-map#${id}`),
                m(`.ol-popup`, { id: `popup-${id}` }, [
                    m(`a.ol-popup-closer`, { id: `popup-closer-${id}`, title: this.getText("LT00000021", "Close") }),
                    m(`.ol-popup-cotent`, { id: `popup-content-${id}` })
                ]),
                this.getBaseViews()
            ];
        }
    }
}